module.exports = __webpack_public_path__ + "static/media/swift-logo.78fa05da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swift-logo.png
// module id = 183
// module chunks = 0